import { useQuery } from "react-query";
import { searchProducerCodes } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

const useSearchProducerCode = ({ filterParams }) => {
  return useQuery(["SearchProducerCode", filterParams], searchProducerCodes, {
    refetchOnWindowFocus: false,
    enabled: false,
  });
};

export default useSearchProducerCode;
